import React, { useEffect } from 'react';
import { Box, Button, Divider } from '@roo/roo';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useUserData } from './UserData';
import { clearLocalUserData } from './UserData/user';
import { getAuthUrl } from '../utils/config';
import h1 from '../assets/images/header_left_1.png';
import h2 from '../assets/images/header_left_2a.png';
import { leaveTip } from '../utils/utils';

import '../assets/styles/header.scss';

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  button {
    padding-right: 0;
  }
  .fh-plate {
    height: 20px;
    font-size: 14px;
    line-height: 20px;
  }
`;

function Header({ title, plate }) {
  const { userName } = useUserData();
  useEffect(() => {
    leaveTip();
  }, []);
  return (
    <Root className="header form-header" htmlType="header" justifyContent="space-between">
      <Box>
        <Link to="/home" style={{ marginTop: 15 }}>
          <img className="logo1" src={h1} alt="美团logo" style={{ height: 30, marginRight: 15 }} />
          <img className="logo2" src={h2} alt="青山logo" style={{ height: 30 }} />
          <p className="fh-title">{title}</p>
        </Link>
        <Divider type="vertical" style={{ height: 12, top: 0 }} />
        <div className="fh-plate">{plate}</div>
      </Box>

      <Box>
        <Button type="text">{userName}</Button>
        <Divider type="vertical" style={{ height: 12, top: 0 }} />
        <Button
          type="text"
          onClick={() => {
            const { logOutUrl } = getAuthUrl();
            window.location.href = logOutUrl;
            clearLocalUserData();
          }}
        >
          退出登录
        </Button>
      </Box>
    </Root>
  );
}

export default Header;
